export const Educations = [
  {
    id: 2,
    school: 'KAIST',
    degree: 'School of Computing (Human-Computer Interaction)',
    location: 'Daejeon, Korea',
    period: '2025.09 - Present',
  },
  {
    id: 1,
    school: 'Ewha Womans University',
    degree: 'B.A. Educational Technology, B.S. Software',
    gpa: '4.13 / 4.3 (Summa Cum Laude)',
    location: 'Seoul, Korea',
    period: '2019.03 - 2025.08',
  },
];